/** @format */

import {clampValue} from 'helpers/numberHelpers';

import {MIN_BODY_HEIGHT, WINDOW_PADDING} from '../constants';

/**
 * Позволяет контейнеру таблицы не превышать лимиты по высоте.
 * @param headHeight
 * @param tableHeight
 * @param dataLength
 */

const getClampedHeight = (headHeight: number, tableHeight: number, dataLength: number): number => {
  const minHeight = headHeight + MIN_BODY_HEIGHT;

  if (dataLength === 0) {
    return minHeight;
  }

  const maxHeight = window.innerHeight - WINDOW_PADDING;

  return clampValue({
    value: tableHeight,
    max: maxHeight,
    min: minHeight,
  });
};

export {getClampedHeight};
